/**
 * 공통 에러 코드 (도메인 무관).
 * 이름 규칙: `<HTTP 의미>_<DOMAIN>_<REASON>`. message 는 개발자용 기본 문구다.
 * 사용자 문구는 FE 의 code → 문구 맵이 소유한다.
 */
export const COMMON_ERROR = {
  UNKNOWN_ERROR: { status: 500, message: 'Unexpected error' },
  BAD_REQUEST_INVALID_PARAMETERS: { status: 400, message: 'Invalid parameters' },
  UNAUTHORIZED: { status: 401, message: 'Authentication required' },
  UNAUTHORIZED_TOKEN_EXPIRED: { status: 401, message: 'Access token expired' },
  FORBIDDEN: { status: 403, message: 'Permission denied' },
  NOT_FOUND: { status: 404, message: 'Resource not found' },
  CONFLICT: { status: 409, message: 'Conflict' },
  PAYLOAD_TOO_LARGE: { status: 413, message: 'Payload too large' },
  TOO_MANY_REQUESTS: { status: 429, message: 'Too many requests' },
  SERVICE_UNAVAILABLE: { status: 503, message: 'Service unavailable (maintenance)' },
} as const satisfies ErrorRegistryShape;

export interface ErrorRegistryEntry {
  readonly status: number;
  readonly message: string;
}

export type ErrorRegistryShape = Readonly<Record<string, ErrorRegistryEntry>>;
